import { useMemo } from 'react'

const getReturnItem = (orderItemId, returns) => {
  if (Array.isArray(returns)) {
    return returns?.find(retItem => retItem.order_item_id === orderItemId)
  }
  return returns?.order_item_id === orderItemId ? returns : null
}

const isEligibleForLifetimeReplacement = (item, returnRequest) => {
  const { return: returns } = { ...returnRequest }
  const { order_item_id: orderItemId, qty } = { ...item }
  const returnItem = getReturnItem(orderItemId, returns)
  return !returnItem || returnItem?.qty_to_return < qty
}

const useGetItemToReturn = ({
  orderDetails,
  partSku,
}) => useMemo(() => {
  let item
  const { parts, return_request: returnRequest } = { ...orderDetails }
  parts?.forEach(part => {
    if (item) return
    if (part?.components?.length > 0) {
      parts?.components?.forEach(childPart => {
        const isEligible = isEligibleForLifetimeReplacement(childPart, returnRequest)
        if (
          partSku &&
          partSku === childPart?.sku &&
          isEligible
        ) {
          item = childPart
        }
      })
    }
    const isEligible = isEligibleForLifetimeReplacement(part, returnRequest)
    if (
      partSku &&
      partSku === part?.sku &&
      isEligible
    ) {
      item = part
    }
  })

  return item
}, [orderDetails, partSku])

export default useGetItemToReturn
